const initialState = {
    loaded: false,
    loading: false,
    content: [],
};

const app = (state = initialState, action) => {
    switch (action.type) {
        case 'MATCHPLAY_PAGE_CONTENT_V2:FETCH_CONTENT_REQUEST':
            return {
                ...state,
                loading: true,
            };
        case 'MATCHPLAY_PAGE_CONTENT_V2:FETCH_CONTENT_SUCCESS':
            return {
                ...state,
                loading: false,
                loaded: true,
                content: action.data,
            };
        case 'MATCHPLAY_PAGE_CONTENT_V2:FETCH_CONTENT_FAILURE':
            return {
                ...state,
                loading: false,
                loaded: false,
                content: [],
            };
        default:
            return state;
    }
};

export default app;
